import getVisibilityImage from "./getVisibilityImage";
import getSubStatusImage from "./getSubStatusImage";
import getMarkerImage from "./getMarkerImage";
import getFatigue from "./getFatigue";

import store from "../store/index";
//--------------------------------
// load specific combatant images
//--------------------------------
export default function loadSpecificCombatantImages(parm) {
  // console.log("---------------------");
  // console.log("IN loadSpecificCombatantImages idx = " + parm.idx);
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //---------------------------------------
  // load combatant image (where provided)
  //---------------------------------------
  if (parm.img) {
    combatants[parm.idx].image = parm.img.image;
  }
  //-----------------------
  // load sub-status image
  //-----------------------
  let sub_status_image = getSubStatusImage(combatants[parm.idx].sub_status);
  combatants[parm.idx].sub_status_image = sub_status_image;
  //-----------------------
  // load visibility image
  //-----------------------
  let visibility_image = getVisibilityImage(combatants[parm.idx].visibility);
  combatants[parm.idx].visibility_image = visibility_image;
  //--------------------
  // load fatigue image
  //--------------------
  let fatigue = getFatigue(combatants[parm.idx].fatigue);
  combatants[parm.idx].fatigue_image = fatigue.image;
  //---------------------
  // load bleeding image
  //---------------------
  let bleeding_image = getMarkerImage("bleeding");
  combatants[parm.idx].bleeding_image = bleeding_image;
  //---------------------
  // load surprise image
  //---------------------
  let surprise_image = getMarkerImage("surprised");
  combatants[parm.idx].surprise_image = surprise_image;
}
